import { useInsightStore } from '../stores/insightStore'

/** App-side query registration delegates its string payload here to preserve the feature boundary. */
export function openInsightFromQuery(value: string): void {
  const insightId = Number(value)
  if (!Number.isSafeInteger(insightId) || insightId <= 0) return
  useInsightStore().openInsight(insightId)
}
